




import Vue, { PropType, PropOptions } from 'vue'
import IObserverOptions from './interfaces/IObserverOptions'

export default Vue.extend({
    name: 'Observer',
    props: {
        options: {
            type: Object as PropType<IObserverOptions>,
            default: () => ({}),
        } as PropOptions<IObserverOptions>,
    },
    data: () => ({
        observer: null as null | IntersectionObserver,
    }),
    mounted(): void {
        this.observer = new IntersectionObserver(([entry]): void => {
            entry.isIntersecting ? this.$emit('intersectOn') : this.$emit('intersectOff')
        }, this.options)

        this.observer.observe(this.$el)
    },
    destroyed(): void {
        if (this.observer) this.observer.disconnect()
    },
})
